import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ElementRef, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { planworkConfig } from 'app/planwork.config';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonModalComponent } from './common-modal/common-modal.component';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ApiService } from '@planwork/services/api.service';
import { ApiVarible } from '@planwork/utils/apiURL';
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  config: any;
  SpinnerTimeout = 500;
  ClientIP: any;
  IPAddress: any;
  apiUrl: any;
  apiUrlCampaign: any;
  private baseUrl: any;
  private otherActivityUrl: any;
  dialogRef: any;
  exceptionText = 'There are some exception error, Please contact to support team.';
  userPermissions: any = {};
  permissionsSource = new BehaviorSubject<any[]>([]);
  permissions$ = this.permissionsSource.asObservable();
  sharingData:any;
  supportUrl: string;
  params: any;
  user:any;
  constructor(
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    public location: Location,
    private toastr: ToastrService,
    public apiService: ApiService,
    public router: Router
  ) {
    this.user = localStorage.getItem('Company');
    this.user = JSON.parse(this.user);
    this.apiUrl = planworkConfig;
    this.baseUrl = this.apiUrl.baseUrl + this.apiUrl.VendorBaseUrl + 'Vendor/';
    this.supportUrl = this.apiUrl.baseUrl + this.apiUrl.SupportBaseUrl + 'Master/';

  }

  commonService(saveData: any, currentUrl: any): Observable<any> {
    const currentToken = localStorage.getItem('token');
    const sbuid = localStorage.getItem('SbuId');
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + currentToken,
      SbuId: sbuid ? sbuid : '0'
    });
    return this.http.post(this.baseUrl + currentUrl, saveData, {
      headers: httpHeaders,
      observe: 'response'
    }).pipe(
      catchError(err => {
        this.spinner.hide();
        this.dialogRef = this.dialog.open(CommonModalComponent, {
          width: '300px',
          disableClose: true,
          autoFocus: false,
          panelClass: 'statusClass',
          data: { action: 'delete', statusText: this.exceptionText }
        });
         this.dialogRef.afterClosed().subscribe(result => {
        if (result === true) {
          window.location.reload(); // <-- Full window reload
        }
      });

        return throwError(err);
      })
    );
  }
  SupportService(saveData: any, currentUrl: any): Observable<any> {
    const currentToken = localStorage.getItem('token');
    const sbuid = localStorage.getItem('SbuId');
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + currentToken,
      SbuId: sbuid ? sbuid : '0'
    });
    return this.http.post(this.supportUrl + currentUrl, saveData, {
      headers: httpHeaders,
      observe: 'response'
    }).pipe(
      catchError(err => {
        this.spinner.hide();
        this.dialogRef = this.dialog.open(CommonModalComponent, {
          width: '300px',
          disableClose: true,
          autoFocus: false,
          panelClass: 'statusClass',
          data: { action: 'delete', statusText: this.exceptionText }
        });
          this.dialogRef.afterClosed().subscribe(result => {
        if (result === true) {
          window.location.reload(); // <-- Full window reload
        }
      });
        return throwError(err);
      })
    );
  }
  saveData(Data){
    this.sharingData = Data;
  }
  deleteData(){
    this.sharingData = [];
  }
  getData(){
    return this.sharingData;
  }

parseDate(dateObject: Date): any {
  let date = new Date(dateObject);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // getMonth() returns month from 0-11
  const day = date.getDate();
  return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
}
  showError(message: string = 'Something Went Wrong', title: string = 'Error') {
    const config: Partial<IndividualConfig> = {
      timeOut: 3000,
      progressBar: false,
      easing: '300',
      enableHtml: true,
      positionClass: 'toast-bottom-right',
    };

    this.toastr.clear();
    this.toastr.error(message, title, config);
  }
showSuccess(
    message: string = 'Done Successfully',
    title: string = 'Success'
  ) {
    const config: Partial<IndividualConfig> = {
      timeOut: 3000,
      progressBar: true,
      enableHtml: true,
      progressAnimation: 'increasing',
      positionClass: 'toast-bottom-right',
    };

    this.toastr.clear();
    setTimeout(() => {
      this.toastr.success(message, title, config);
    }, 0);
  }
    getYears(prevYear: number = 10, nextYear: number = 1) {
    let currentYear = new Date().getFullYear();
    let minPastYear = currentYear - prevYear;
    return Array.from(
      { length: currentYear + nextYear - minPastYear + 1 },
      (_, i) => minPastYear + i
    );
  }

  getMonths() {
    return Array.from({ length: 12 }, (_, i) => {
      const monthIndex = i + 1;
      const monthName = new Date(0, i).toLocaleString('en-US', {
        month: 'long',
      });
      return { name: monthName, value: monthIndex };
    });
  }
    getPreviousMonthYear(previousCount: number = 1) {
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();
    let month = ((currentMonth - previousCount + 12) % 12) + 1;
    let year = currentMonth - previousCount < 1 ? currentYear - 1 : currentYear;
    return {
      month,
      year,
    };
  }
    getExcelColumnNames(filepath: string) {
    return new Promise((resolve, reject) => {
      this.http
        .get(filepath, { responseType: 'blob' })
        .subscribe((data: Blob) => {
          const reader = new FileReader();
          reader.onload = (event) => {
            try {
              const arrayBuffer = reader.result as ArrayBuffer;
              const uint8Array = new Uint8Array(arrayBuffer);
              const workbook = XLSX.read(uint8Array, { type: 'array' });
              const sheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[sheetName];
              const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, {
                header: 1,
              });
              const columns = jsonData[0].map((item: any) => item.trim());
              resolve(columns);
            } catch (error) {
              reject('Error reading the Excel file');
            }
          };
          reader.readAsArrayBuffer(data);
        });
    });
  }
  // not confirm of this popup
    ConfirmPopup(
    recordType: string = 'Record',
    width: number = 300,
    statusClass: string = 'statusClass'
  ): MatDialogRef<any> {
    return this.dialog.open(CommonModalComponent, {
      width: width + 'px',
      disableClose: true,
      autoFocus: false,
      panelClass: statusClass,
      data: { action: 'delete', statusText: `${recordType}` },
    });
  }
    getTableParams(params: any) {
    const defaultOrder = [{ column: 1, dir: 'desc' }];
    return {
      columns: params?.columns,
      start: params?.start,
      length: params?.length,
      search: params?.search,
      order: params?.order?.length ? params?.order : defaultOrder,
      value: params?.search?.value,
      regex: params?.search?.regex,
    };
  }
    validateExcelColumns(file: File, requiredColumns: any[]) {
    return new Promise((resolve: any, reject: any) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
          });
          const headers = jsonData[0].map((item: any) => item.trim());
          const missingColumns = requiredColumns.filter(
            (column) => !headers.includes(column)
          );

          if (missingColumns.length === 0) {
            resolve(true);
          } else {
            reject(`Missing columns: ${missingColumns.join(', ')}`);
          }
        } catch (error) {
          reject('Error reading the Excel file');
        }
      };
      reader.readAsArrayBuffer(file);
    });
  }
    getExcelJSON(file: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        try {
          const data = new Uint8Array(reader.result as ArrayBuffer);
          const workbook = XLSX.read(data, { type: 'array' });
          const worksheet = workbook.Sheets[workbook.SheetNames[0]];
          const jsonData = XLSX.utils.sheet_to_json(worksheet, {
            // skipHidden: true,
            // blankrows: false
            // skipHidden: true,
            blankrows: false,
            defval: '', // Set default value for empty cells
          });
          let trimmedJson = jsonData.map((obj: any) => {
            let newObj: { [key: string]: any } = {};
            Object.keys(obj).forEach((key) => {
              newObj[key.trim()] =
                typeof obj[key] === 'string' ? obj[key].trim() : obj[key];
            });
            return newObj;
          });
          resolve(trimmedJson);
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(file);
    });
  }
    imageUpload(fileEvent: any, data: any): Observable<any> {
    return new Observable((res) => {
      const files = fileEvent.target.files;
      console.log(files);

      const file = files[0];
      if (files && file) {
        const fileName = file.name;
        const fileExe = fileName.split('.').pop();
        let reader = new FileReader();
        reader.onload = (e: any) => {
          let imagePreview = e.target.result;
          let b;
          b = imagePreview.split('base64,');
          data.DocumentFileName = fileName;
          data.Preview = imagePreview;
          data.FileData = b[1];
          data.FileExe = fileExe;
          data.errorText = '';
          res.next(data);
        };
        reader.readAsDataURL(file);
      }
    });
  }
    generatePdfFromElement(elementRef: ElementRef, pdfName: string) {
    const element = elementRef.nativeElement;
    if (element) {
      html2canvas(element).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(pdfName);
      });
    }
  }
    expandCellExcel(sheet: any) {
    sheet.columns.forEach((column: any) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell: any) => {
        const cellValue = cell.value ? cell.value.toString() : '';
        maxLength = Math.max(maxLength, cellValue.length);
      });
      column.width = maxLength < 10 ? 10 : maxLength;
    });
  }
  
  saveExcelFile(buffer: Buffer, fileName: string) {
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = url;
    a.download = fileName + '.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }

  //  loadUserPermissions(): Promise<void> {
  //   return new Promise<void>((resolve, reject) => {
  //     if (this.user) {
  //       this.apiService
  //         .postAPI({}, `${ApiVarible.GetRolePermissionByEmployeeId}`)
  //         .subscribe(
  //           (res: any) => {
  //             let userPermissionData = res.body.Result.RolePermissionList;

  //             let permissionData = userPermissionData.map(
  //               (permission: any) => ({
  //                 TaskId: permission.TaskId,
  //                 action: permission.PermissionTypeId.replace(/\s/g, '')
  //                   .split('|')
  //                   .reduce(
  //                     (acc: any, current: any) => ({ ...acc, [current]: true }),
  //                     {}
  //                   ),
  //               })
  //             );

  //             this.userPermissions = permissionData.reduce(
  //               (acc: any, curr: any) => {
  //                 if (!acc[curr.TaskId]) {
  //                   acc[curr.TaskId] = {
  //                     action: this.getFilteredpermission(curr.action),
  //                   };
  //                 } else {
  //                   acc[curr.TaskId] = {
  //                     action: this.getFilteredpermission({
  //                       ...acc[curr.TaskId].action,
  //                       ...curr.action,
  //                     }),
  //                   };
  //                 }
  //                 return acc;
  //               },
  //               {}
  //             );

  //             // console.log('this.userPermissions: ', this.userPermissions);

  //             setTimeout(() => {
  //               this.permissionsSource.next(this.userPermissions);
  //               resolve();
  //             }, 100);
  //           },
  //           (error) => {
  //             reject(error);
  //           }
  //         );
  //     }
  //   });
  // }
    getFilteredpermission(mergeData: any) {
    return Object.fromEntries(
      Object.entries(mergeData).filter(([key]) => key !== '')
    );
  }
    goBack(): void {
    this.location.back();
  }
}
